/*
 * jQuery autoResize (textarea auto-resizer)
 * @copyright James Padolsey http://james.padolsey.com
 * @version 1.04
 */
(function(a) {
  a.fn.autoResize = function(j) {
    var b = a.extend(
      {
        onResize: function() {},
        animate: true,
        animateDuration: 150,
        animateCallback: function() {},
        extraSpace: 20,
        limit: 1000
      },
      j
    );
    this.filter("textarea").each(function() {
      var c = a(this).css({ resize: "none", "overflow-y": "hidden" }),
        k = c.height(),
        f = (function() {
          var l = [
              "height",
              "width",
              "lineHeight",
              "textDecoration",
              "letterSpacing"
            ],
            h = {};
          a.each(l, function(d, e) {
            h[e] = c.css(e);
          });
          return c
            .clone()
            .removeAttr("id")
            .removeAttr("name")
            .css({ position: "absolute", top: 0, left: -9999 })
            .css(h)
            .attr("tabIndex", "-1")
            .insertBefore(c);
        })(),
        i = null,
        g = function() {
          f.height(0)
            .val(a(this).val())
            .scrollTop(10000);
          var d = Math.max(f.scrollTop(), k) + b.extraSpace,
            e = a(this).add(f);
          if (i === d) {
            return;
          }
          i = d;
          if (d >= b.limit) {
            a(this).css("overflow-y", "");
            return;
          }
          b.onResize.call(this);
          b.animate && c.css("display") === "block"
            ? e
                .stop()
                .animate({ height: d }, b.animateDuration, b.animateCallback)
            : e.height(d);
        };
      c.unbind(".dynSiz")
        .bind("keyup.dynSiz", g)
        .bind("keydown.dynSiz", g)
        .bind("change.dynSiz", g);
    });
    return this;
  };
})(jQuery);

function isInt(x) {
  var y = parseInt(x);
  if (isNaN(y)) return false;
  return x == y && x.toString() == y.toString();
}
function isFloat(x) {
  var y = parseFloat(x);
  if (isNaN(y)) return false;
  return x == y && x.toString() == y.toString();
}
function IntToHex(number) {
  var f = Math.floor(number / 16);
  var s = hexnb(number - f * 16);
  return String(hexnb(f)) + s;
}
function hexnb(number) {
  var abc = new Array("A", "B", "C", "D", "E", "F");
  if (number < 10) return number;
  else return abc[number - 10];
}
function rgbToHex(rgb) {
  var parts = rgb.split(",");
  var first = parts[0].split("(");
  return (
    "#" +
    String(IntToHex(parseInt(first[1]))) +
    String(IntToHex(parseInt(parts[1]))) +
    String(IntToHex(parseInt(parts[2])))
  );
}
function rgbToHex2(rgb) {
  var parts = rgb.split(",");
  var first = parts[0].split("(");
  return (
    String(IntToHex(parseInt(first[1]))) +
    String(IntToHex(parseInt(parts[1]))) +
    String(IntToHex(parseInt(parts[2])))
  );
}
function ajax_call(module_data, callback, type) {
  var data = {
    malinaAjaxCall_hash: HASH,
    malinaAjaxCall_module: module_data.module,
    malinaAjaxCall_function: module_data.action,
    malinaAjaxCall_type: module_data.type,
    malinaAjaxCall_public: module_data.public || false,
    malinaAjaxCall_tpl: TEMPLATE
  };
  jQuery.extend(data, module_data.args);

  $.ajax({
    type: "POST",
    url: PROTOCOL + HOST + PATH + "run",
    data: data,
    dataType: type,
    success: function(data) {
      if (type == "json") {
        if (data !== null) {
          // Error handling
          if (typeof data.errorMSG != "undefined") {
            if (data.errorTYPE == "CSRF") $.facebox(data.errorMSG);
            else $.facebox("<h2>Error!</h2><span>" + data.errorMSG + "</span>");
            if (data.errorTYPE == "FATAL") return;
          }
          // Console
          if (typeof data.console != "undefined") console.log(data.console);
        }
      }

      callback(data);
    }
  });
}
function input_filter(element, counterId, maxlength) {
  if (maxlength === undefined) maxlength = 2000;

  var value = element.value;
  var len = value.length;
  if (len > maxlength) {
    element.value = value.substr(0, maxlength);
    len = maxlength;
  }

  $("#" + counterId).html(maxlength - len);
}
function register_click(zone) {
  ajax_call(
    {
      module: "ClickStats",
      action: "registerClick",
      type: 0,
      args: {
        zone: zone
      }
    },
    function(data) {},
    "json"
  );
}
//var kb = new Array();
/*function keyboardListener() {
 $(document).bind("keyup",function(event) {
 var key = event.keyCode? event.keyCode : event.charCode;
 if(key==39)
 $("#url").html("A pojdeme ->");
 if(key==37)
 $("#url").html("A pojdeme <-");
 });

 $(document).bind("keydown","ctrl+z",function() {
 //if(parseInt($("#url").html())=="NaN")
 //	$("#url").html("gesture, 0");
 $("#url").html(typeof(parseInt($("#url").html())));
 //else
 //	$("#url").html("gesture, "+(parseInt($("#url").html())+1));
 });
 }*/

/**
 * Prepne na nejaku subdomenu, kedze standardy maju vsetky browsery
 * maaaximalne v pici, treba to urobit takto kokotsky (ci pana ale som nasraty)
 *
 * @param domain - domena, cize teraz.teraz.sk alebo tak nejak
 */
function switchDomain(domain) {
  var w = window.location;
  var url = w.protocol + "//" + domain + w.pathname;
  window.location = url;
}

/*
 * Init shit
 */
if (typeof jQuery != "undefined") {
  $(document).ready(function() {
    $.ajaxSetup({
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        if (DEBUG) {
          $.facebox(
            "<h2>AJAX ERROR</h2><b>" + textStatus + "</b><br> " + errorThrown
          );
        }
      }
    });

    /*
     * Aby nas nemohli nacitavat vo framoch
     */
    if (
      top != self &&
      self.location.pathname != "/coverflow" &&
      self.location.pathname != "/preview"
    ) {
      top.location.href = self.location.href;
    }

    $("a[rel*=facebox]").facebox();
    $("#facebox table").css({ width: "auto" });

    $(".onFocusClean")
      .focus(function() {
        if ($(this).val() == $(this).attr("default")) $(this).val("");
      })
      .blur(function() {
        if ($(this).val() === "") $(this).val($(this).attr("default"));
      });

    /*$(".disableLinks a").each(function() {
         $(this).attr("href", "#");
         });*/

    /*$(".disableLinks a").click(function() {
         alert(1);
         return false;
         });*/
    /*each(function() {

         $(this).attr("href", "/");

         $(this).on("click", function() {
         alert(1);
         return false;
         });

         });*/

    $("textarea.autoheight")
      .autoResize({
        animateDuration: 150,
        extraSpace: 0
      })
      .trigger("change");
  });
}

function instagram_init() {
  var feed = new Instafeed({
    get: "user",
    userId: 1680852135,
    access_token: "232085014.2c5ed62.3a8fb98917d04ac8ab19eb9edd024191",
    clientId: "2c5ed627cb12482bbf0513445ae1aca4",
    limit: 1,
    resolution: "standard_resolution"
  });
  feed.run();
}

function splitArticle_init() {
  $(".split-parts-load-more").on("click", function() {
    $(".split-part.active").removeClass("split-part");
    $(".split-part.active").removeClass("active");
    if ($(".split-part").length > 0){
      $(".split-part").first().addClass('active');
    } else {
      $(".split-parts-load-more").remove();
    }
  });
}

$(function() {
  $("img.unveil").unveil();
});
